// ** Initial user ability
export const initialAbility = [
  {
    action: 'read',
    subject: 'Auth'
  },
  {
    action: 'read',
    subject: 'Home'
  }
]

export const _ = undefined
